<mat-card appearance="outlined">
  <mat-card-content>
    <yr-purchase-status [clientSecret]="clientSecret"></yr-purchase-status>
  </mat-card-content>
</mat-card>
